import { loginByUsername, logout, getUserInfo } from "@/api/login";
import { getUser } from "@/api/system";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { getFullRolesId, getToleRoles } from '@/utils/rolesMap'
import { routerRole } from '@/router'
const totleList = getToleRoles()
const user = {
  state: {
    user: "",
    status: "",
    code: "",
    token: getToken(),
    name: "",
    avatar: "",
    introduction: "",
    roles: ["admin"],
    rolesId: [],
    setting: {
      articlePlatform: [],
    },
    defaultPath: '',
    roleStatus:window.localStorage.getItem('roleStatus')?window.localStorage.getItem('roleStatus'):'false',
    superUserIds: [1, 2, 6,7], //为主账号
    allList: window.localStorage.getItem('allList') === '1'
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction;
    },
    // SET_SETTING: (state, setting) => {
    //   state.setting = setting
    // },
    // SET_STATUS: (state, status) => {
    //   state.status = status
    // },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_ROLE_STATUS: (state, roleStatus) => {
      state.roleStatus = roleStatus;
      window.localStorage.setItem('roleStatus',roleStatus)
    },
   
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_ROLES_ID: (state, rolesId) => {
      state.rolesId = rolesId;
    },
    SET_DEFAULT_PATH: (state, defaultPath) => {
      state.defaultPath = defaultPath;
    },
    SET_ALL_LIST: (state, flag) => {
      state.allList = flag
      window.localStorage.setItem('allList', flag ? '1' : '0')
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit, state, dispatch }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password)
          .then((response) => {
            const data = response.data.data; 
            commit("SET_TOKEN", data.token);
            window.localStorage.setItem('userId', data.user.userId)
            let rolesId = []
            if (state.superUserIds.includes(data.user.userId)) {
              rolesId = totleList
              rolesId.push(-1)
            } else {
              data.user.roles.forEach(v => {
                rolesId = [...rolesId, ...v.permissions]
              })
            }
            rolesId = Array.from(new Set(rolesId))
            commit("SET_NAME", data.user.username) 
            commit("SET_ROLE_STATUS", 'false')
             data.user.roles.forEach( item =>{
              if(item.roleId==1){
                commit("SET_ROLE_STATUS", 'true')
              }
              


            })
            rolesId.forEach( item =>{
              if(item==-1){
                commit("SET_ROLE_STATUS", 'false')
              }
              


            })
            const fullRolesId = getFullRolesId(rolesId)
            commit("SET_ROLES_ID", fullRolesId );
            setToken(data.token);
            // dispatch('GenerateRoutes', state.roles) // 动态修改权限后 重绘侧边菜单
            resolve(fullRolesId);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        const id = window.localStorage.getItem('userId')
        getUser({ userId: id }).then((response) => {
          const data = response.data.data
          let rolesId = []
          if (state.superUserIds.includes(data.userId)) {
            rolesId = totleList
            rolesId.push(-1)
          } else {
            data.roles.forEach(v => {
              rolesId = [...rolesId, ...v.permissions]
            })
          }



          // rolesId.forEach(v => {
          //   if(v==16){
          //     return
          //   }

          // })
          // // rolesId.forEach(v => {
          // //   if(v==50){
          // //     return
          // //   }else if(50<v<60){
          // //     rolesId.push(50)
          // //     return
          // //   }

          // // })
          // rolesId.forEach(v => {
          //   if(v==60){
          //     return
          //   }else if(v>60){
          //     rolesId.push(60)
          //     rolesId.push(16)
          //     return
          //   }

          // })
          let arr =rolesId
          if (arr.some(x => x > 50)) {
            const needs16 = !arr.includes(16);
            const hasAbove60 = arr.some(x => x > 60);
            const allBelow60 = arr.every(x => x <= 60);
            
            if (hasAbove60) {
                // Case 1: Contains numbers >60 and missing 16 or 60
                const needs60 = !arr.includes(60);
                if (needs16) {
                    arr.push(16);
                }
                if (needs60) {
                    arr.push(60);
                }
            } else if (allBelow60) {
                // Case 2: All numbers <=60 and missing 16 or 50
                const needs50 = !arr.includes(50);
                if (needs16) {
                    arr.push(16);
                }
                if (needs50) {
                    arr.push(50);
                }
            } else {
                // Case 3: Mixed case (some <=60, some >60)
                const needs50 = !arr.includes(50);
                const needs60 = !arr.includes(60);
                if (needs16) {
                    arr.push(16);
                }
                if (needs50) {
                    arr.push(50);
                }
                if (needs60) {
                    arr.push(60);
                }
            }
          }
          arr=arr.sort((a, b) => a - b)
          console.log(arr)


          rolesId = Array.from(new Set(rolesId))
          const fullRolesId = getFullRolesId(rolesId)
          let path = "";
          for (let i in routerRole) {
            if (fullRolesId.indexOf(Number(i)) > -1) {
              path = routerRole[i]
              break
            }
          }
          commit("SET_NAME", data.username)
          commit("SET_ROLES_ID", fullRolesId);
          commit("SET_DEFAULT_PATH", path);
          resolve(fullRolesId);
        })
          .catch((error) => {
            reject(error);
          });
      });
    },

  

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("SET_ROLES", []);
        removeToken();
        resolve();
      });
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", role);
        setToken(role);
        getUserInfo(role).then((response) => {
          const data = response.data;
          commit("SET_ROLES", data.roles);
          commit("SET_NAME", data.name);
          commit("SET_AVATAR", data.avatar);
          commit("SET_INTRODUCTION", data.introduction);
          dispatch("GenerateRoutes", data); // 动态修改权限后 重绘侧边菜单
          resolve();
        });
      });
    },
    setAllList({ commit }, flag) {
      commit('SET_ALL_LIST', flag)
    },
  },
};

export default user;
